import { Link, LinkProps } from 'react-router-dom'

interface ButtonProps extends LinkProps {
  variant?: 'primary' | 'secondary' | 'tertiary'
  children: React.ReactNode
  className?: string
}

export const ButtonLink = ({
  variant = 'primary',
  children,
  className = 'h-12 w-full',
  ...props
}: ButtonProps) => {
  const baseStyles = "py-3 px-6 rounded-full font-semibold transition-all duration-10 inline-block text-center text-[0.9375rem]"
  const variants = {
    primary: "bg-blue-600 text-white active:opacity-90 touch-none",
    secondary: "bg-white text-blue-600 border border-blue-600 active:bg-gray-100 touch-none",
    tertiary: "bg-transparent text-blue-600 active:bg-gray-100 touch-none"
  }

  return (
    <Link
      className={`${baseStyles} ${variants[variant]} ${className}`}
      {...props}
    >
      {children}
    </Link>
  )
}

export default ButtonLink